const barcodeFormat = [
  {
    type: "1D",
    id: "ipt-1dFormat",
    btnToggleId: "btn-toggle1Ds",
    value: "BF_ONED",
    index: 0,
    selected: true,
    children: [
      {
        type: "Code 11",
        id: "ipt-code11",
        value: "BF_CODE_11",
        selected: true,
      },
      {
        type: "Code 39",
        id: "ipt-code39",
        value: "BF_CODE_39",
        selected: true,
      },
      {
        type: "Code 39 Extended",
        id: "ipt-Code39Extended",
        value: "BF_CODE_39_EXTENDED",
        selected: true,
      },
      {
        type: "Code 128",
        id: "ipt-code128",
        value: "BF_CODE_128",
        selected: true,
      },
      {
        type: "Code 93",
        id: "ipt-code93",
        value: "BF_CODE_93",
        selected: true,
      },
      {
        type: "Codebar",
        id: "ipt-codebar",
        value: "BF_CODABAR",
        selected: true,
      },
      {
        type: "ITF",
        id: "ipt-itf",
        value: "BF_ITF",
        selected: true,
      },
      {
        type: "EAN13",
        id: "ipt-ean13",
        value: "BF_EAN_13",
        selected: true,
      },
      {
        type: "EAN8",
        id: "ipt-ean8",
        value: "BF_EAN_8",
        selected: true,
      },
      {
        type: "UPC A",
        id: "ipt-upca",
        value: "BF_UPC_A",
        selected: true,
      },
      {
        type: "UPC E",
        id: "ipt-upce",
        value: "BF_UPC_E",
        selected: true,
      },
      {
        type: "INDUSTRIAL 25",
        id: "ipt-industrial25",
        value: "BF_INDUSTRIAL_25",
        selected: true,
      },
      {
        type: "MSI Code",
        id: "ipt-msicode",
        value: "BF_MSI_CODE",
        selected: true,
      },
    ]
  },
  {
    type: "PDF417",
    id: "ipt-pdf417",
    value: ["BF_PDF417", "BF_MICRO_PDF417"],
    selected: true,
  },
  {
    type: "QR Code",
    id: "ipt-QRCode",
    value: ["BF_QR_CODE", "BF_MICRO_QR"],
    selected: true,
  },
  {
    type: "DataMatrix",
    id: "ipt-DataMatrix",
    value: "BF_DATAMATRIX",
    selected: true,
  },
  {
    type: "GS1 Databar",
    id: "ipt-GS1DatabarFormat",
    btnToggleId: "btn-toggleGS1Databars",
    value: "BF_GS1_DATABAR",
    index: 1,
    selected: true,
    children: [
      {
        type: "GS1 Databar Omnidirectional",
        id: "ipt-OMNIDIRECTIONAL",
        value: "BF_GS1_DATABAR_OMNIDIRECTIONAL",
        selected: true,
      },
      {
        type: "GS1 Databar Truncated",
        id: "ipt-TRUNCATED",
        value: "BF_GS1_DATABAR_TRUNCATED",
        selected: true,
      },
      {
        type: "GS1 Databar Stacked",
        id: "ipt-STACKED",
        value: "BF_GS1_DATABAR_STACKED",
        selected: true,
      },
      {
        type: "GS1 Databar Stacked Omnidirectional",
        id: "ipt-SO",
        value: "BF_GS1_DATABAR_STACKED_OMNIDIRECTIONAL",
        selected: true,
      },
      {
        type: "GS1 Databar Expanded",
        id: "ipt-EXPANDED",
        value: "BF_GS1_DATABAR_EXPANDED",
        selected: true,
      },
      {
        type: "GS1 Databar Expanded Stacked",
        id: "ipt-ES",
        value: "BF_GS1_DATABAR_EXPANDED_STACKED",
        selected: true,
      },
      {
        type: "GS1 Databar Limited",
        id: "ipt-LIMITED",
        value: "BF_GS1_DATABAR_LIMITED",
        selected: true,
      },
    ]
  },
  {
    type: "Aztec Code",
    id: "ipt-Aztec",
    value: "BF_AZTEC",
    selected: true,
  },
  {
    type: "Maxicode",
    id: "ipt-Maxicode",
    value: "BF_MAXICODE",
    selected: true,
  },
  {
    type: "Patch Code",
    id: "ipt-Patch",
    value: "BF_PATCHCODE",
    selected: true,
  },
  {
    type: "Postal Code",
    id: "ipt-postalCodeFormat",
    btnToggleId: "btn-togglePostalCodes",
    value: "BF_POSTALCODE",
    index: 2,
    selected: true,
    children: [
      {
        type: "USPS Intelligent Mail",
        id: "ipt-USPSINTELLIGENTMAIL",
        value: "BF_USPSINTELLIGENTMAIL",
        selected: true,
      },
      {
        type: "Postnet",
        id: "ipt-POSTNET",
        value: "BF_POSTNET",
        selected: true,
      },
      {
        type: "Planet",
        id: "ipt-PLANET",
        value: "BF_PLANET",
        selected: true,
      },
      {
        type: "Australian Post",
        id: "ipt-AUSTRALIANPOST",
        value: "BF_AUSTRALIANPOST",
        selected: true,
      },
      {
        type: "UK Royal Mail(RM4SCC)",
        id: "ipt-RM4SCC",
        value: "BF_RM4SCC",
        selected: true,
      }
    ]
  },
  {
    type: "DotCode",
    id: "ipt-dotCode",
    value: "BF_DOTCODE",
    selected: true,
  },
  {
    type: "Pharmacode",
    id: "ipt-pharmaCodeFormat",
    btnToggleId: "btn-togglePharmacodes",
    value: "BF_PHARMACODE",
    index: 3,
    selected: false,
    children: [
      {
        type: "Pharmacode One-Track",
        id: "ipt-PHARMACODE_ONE_TRACK",
        value: "BF_PHARMACODE_ONE_TRACK",
        selected: false
      },
      {
        type: "Pharmacode Two-Track",
        id: "ipt-PHARMACODE_TWO_TRACK",
        value: "BF_PHARMACODE_TWO_TRACK",
        selected: false
      },
    ]
  },
  {
    type: "GS1 Composite",
    id: "ipt-GS1COMPOSITE",
    value: "BF_GS1_COMPOSITE",
    selected: true,
  }
]

export type FormatChildren = {
  type: string;
  id: string;
  value: string;
  selected: boolean;
}[]

export default barcodeFormat;